module.exports = __webpack_public_path__ + "img/56ne.a84548ed.svg";